import React, { useState, useEffect } from "react";
import { Box, Drawer, Button, Typography, Divider } from "@mui/material";
import { onAuthStateChangedListener, logout } from "./firebaseServices";
import CategoryGrid from "./CategoryGrid";
import ImgByCat from "./ImgByCat";
import ProductSearch from "./ProductSearch";
import { handleProductSkuSearch } from "./categoryServices";
import GetLogos from "./GetLogos";

function UserPage() {
  const [userEmail, setUserEmail] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchTerm, setSearchTerm] = useState(""); // Holds the input value
  const [searchResults, setSearchResults] = useState(null); // Holds search results
  const [logos, setLogos] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChangedListener((user) => {
      if (user) setUserEmail(user.email);
      else setUserEmail(null);
    });

    return () => unsubscribe();
  }, []);

  const handleCategoryClick = (category) => {
    console.log("Clicked category:", category);
    setSelectedCategory(category);
    setLogos(false);
  };

  const onLogoClick = () => {
    setLogos(true);
    setSelectedCategory(null);
    setSearchResults(null);
    setSearchTerm("");
  };

  const handleBack = () => setSelectedCategory(null);

  const handleLogout = async () => {
    try {
      await logout();
      console.log("Logged out successfully");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  const handleNameSearch = async () => {
    try {
      const normalizedSearchTerm = searchTerm.trim().toUpperCase(); // Normalize search term
      const searchResults = await handleProductSkuSearch(normalizedSearchTerm);

      setSearchResults(searchResults); // Update state with results
      setSelectedCategory(null); // Clear selected category
      setLogos(false); // Clear logos
    } catch (error) {
      console.error("Error during search:", error);
      setSearchResults([]); // Clear results on error
    }
  };

  const handleShowCategories = () => {
    setSelectedCategory(null);
    setSearchResults(null);
    setSearchTerm("");
    setLogos(false);
  };
  return (
    <Box sx={{ display: "flex", minHeight: "100vh", height: "100%" }}>
      <Drawer
        variant="permanent"
        sx={{
          width: 270,
          "& .MuiDrawer-paper": { width: 270, boxSizing: "border-box" },
        }}
      >
        <Box sx={{ padding: 2 }}>
          <img
            src="https://firebasestorage.googleapis.com/v0/b/officialimages-523a5.firebasestorage.app/o/img%2FDL_Logo_plain_72dpi.png?alt=media&token=e9013a5b-ac45-43c6-b6ca-98938b1b9480"
            alt="DL Logo"
            width="200"
          />
          <Typography variant="h6" sx={{ marginBottom: 3 }}>
            Distributor Resources
          </Typography>

          {userEmail ? (
            <>
              <Typography variant="body1">Logged in as:</Typography>
              <Typography fontWeight="bold" sx={{ mb: 2 }}>
                {userEmail}
              </Typography>
              <Button variant="outlined" color="error" fullWidth sx={{ marginTop: 1 }} onClick={handleLogout}>
                Log Out
              </Button>
            </>
          ) : (
            <Typography fontWeight="bold">Not logged in</Typography>
          )}
        </Box>
        <Divider />
        <Box sx={{ padding: 2 }}>
          <Button variant="outlined" fullWidth onClick={handleShowCategories}>
            Browse Products
          </Button>
        </Box>

        <Box sx={{ padding: 2 }}>
          <Button variant="outlined" fullWidth onClick={onLogoClick}>
            Browse Logos
          </Button>
        </Box>

        <Divider />
        <Box sx={{ padding: 2 }}>
          <Typography variant="h6">Search Product by SKU</Typography>
          <input
            type="text"
            placeholder="Enter product name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: "100%", padding: "5px" }}
          />
          <Button variant="outlined" fullWidth onClick={handleNameSearch} disabled={!searchTerm}>
            Search
          </Button>
        </Box>
      </Drawer>

      <Box sx={{ flexGrow: 1, padding: 3, backgroundColor: "#f5f5f5" }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          {logos ? (
            <Typography variant="body1" sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}>
              Browse Logos
            </Typography>
          ) : (
            <Typography
              variant="body1"
              sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
              onClick={handleShowCategories} // Clears everything
            >
              Product Categories
            </Typography>
          )}

          {selectedCategory && (
            <>
              <Typography variant="body1" sx={{ mx: 1 }}>
                →
              </Typography>
              <Typography variant="body1">{selectedCategory.catName}</Typography>
            </>
          )}

          {searchResults && !selectedCategory && (
            <>
              <Typography variant="body1" sx={{ mx: 1 }}>
                →
              </Typography>
              <Typography variant="body1">Search Results</Typography>
            </>
          )}
        </Box>
        {selectedCategory && !searchResults ? <ImgByCat category={selectedCategory} onBack={handleBack} /> : null}

        {!selectedCategory && !searchResults && !logos ? <CategoryGrid onCategoryClick={handleCategoryClick} /> : null}

        {searchResults && <ProductSearch searchResults={searchResults} />}

        {logos && !searchResults ? <GetLogos /> : null}
      </Box>
    </Box>
  );
}

export default UserPage;
